import { tokenService } from '../../../services/tokenService';

interface DownloadAdminCsvOptions {
  target: string;
  params?: Record<string, string>;
}

interface CreateDownloadGrantResponse {
  download_path?: string;
}

const downloadGrantPathPattern = /^\/rpc\/v1\/downloads\/grants\/[A-Za-z0-9._:-]+\/content$/;

function toSafeDownloadPath(downloadPath: string): string {
  if (downloadPath.includes('\\')) {
    throw new Error('Export failed - invalid download path');
  }

  try {
    const parsedURL = new URL(downloadPath, window.location.origin);
    if (parsedURL.origin !== window.location.origin) {
      throw new Error('Export failed - invalid download path');
    }
    if (!downloadGrantPathPattern.test(parsedURL.pathname)) {
      throw new Error('Export failed - invalid download path');
    }

    return `${parsedURL.pathname}${parsedURL.search}`;
  } catch {
    throw new Error('Export failed - invalid download path');
  }
}

export async function downloadAdminCsv({
  target,
  params = {},
}: DownloadAdminCsvOptions): Promise<void> {
  const token = await tokenService.getActiveToken();
  if (!token) {
    throw new Error('Not authenticated - please refresh and try again');
  }

  const response = await fetch('/rpc/v1/downloads/grants', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      target,
      params,
    }),
  });

  if (!response.ok) {
    throw new Error(`Export failed with status ${response.status}`);
  }

  const payload = (await response.json()) as CreateDownloadGrantResponse;
  if (!payload.download_path) {
    throw new Error('Export failed - download path missing');
  }

  window.location.assign(toSafeDownloadPath(payload.download_path));
}
